<div class="dlg" aria-modal="true" aria-labelledby="dlg-title">
  <header class="dlg__header">
    <h2 id="dlg-title" class="dlg__title">
      {{
        "service_manager.delay.uncheck_title"
          | translate : { default: "Desmarcar servicio con retraso" }
      }}
    </h2>
    <p class="dlg__subtitle">
      {{
        "service_manager.delay.uncheck_description"
          | translate
            : {
                default:
                  "¿Estás seguro que quieres desmarcar el servicio con retraso?"
              }
      }}
    </p>
  </header>

  <footer class="dlg__footer">
    <button type="button" class="btn btn--ghost" (click)="close()">
      {{ "common.actions.close" | translate : { default: "Cerrar" } }}
    </button>

    <button type="submit" class="btn btn--confirm" (click)="confirm()">
      {{ "common.actions.confirm" | translate : { default: "Confirmar" } }}
    </button>
  </footer>
</div>
